module.exports = __webpack_public_path__ + "static/img/choose-us-2.8fa7445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/choose-us-2.png
// module id = Il+f
// module chunks = 0